// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const EmailIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M16.86 2.5H7.14c-3.2 0-5.64 2.65-5.64 6.07v6.86c0 1.77.66 3.42 1.77 4.53 1 1 2.32 1.55 3.87 1.55h9.72c1.44 0 2.77-.56 3.87-1.55 1.1-1.1 1.77-2.76 1.77-4.53V8.57c0-3.42-2.43-6.08-5.64-6.08"
        opacity=".5"
      />
      <path d="M18.41 9.57 14 13.1q-.83.66-1.99.66-1 0-1.99-.66L5.6 9.46c-.33-.33-.44-.78-.11-1.22s.77-.44 1.21-.1l4.43 3.53c.55.44 1.32.44 1.76 0l4.43-3.54c.33-.33.88-.22 1.21.11.33.44.22 1-.1 1.33" />
    </g>
  </SvgIcon>
);

export default EmailIcon;
